import { ReducerBuilder } from 'typescript-fsa-reducers';

import { applyAsyncReducer } from '@utils';

import { authLogout } from './authLogout';

import { IAuthStore } from '../../types';

export const authLogoutReducer = (auth: ReducerBuilder<IAuthStore, IAuthStore>) => {
	applyAsyncReducer<IAuthStore['user']['data'], IAuthStore['user']['meta']>()(
		'user',
		'networkStatus',
		authLogout.async,
		auth,
		() => ({
			user: null,
		}),
	);
};
